document.addEventListener("DOMContentLoaded", () => {
    // If a link has a dropdown, add sub-menu toggle
    const navLinks = document.querySelectorAll("nav ul li a:not(:only-child)");
    navLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        const dropdown = link.nextElementSibling;
        if (dropdown && dropdown.classList.contains("nav-dropdown")) {
          dropdown.classList.toggle("visible");
  
          // Close other dropdowns when this one is opened
          document.querySelectorAll(".nav-dropdown.visible").forEach((otherDropdown) => {
            if (otherDropdown !== dropdown) {
              otherDropdown.classList.remove("visible");
            }
          });
  
          e.stopPropagation(); // Prevent clicks from propagating to the document
        }
      });
    });
  
    // Clicking away from dropdown will hide all dropdowns
    document.addEventListener("click", () => {
      document.querySelectorAll(".nav-dropdown.visible").forEach((dropdown) => {
        dropdown.classList.remove("visible");
      });
    });
  
    // Toggle open and close nav styles on click
    const navToggle = document.getElementById("nav-toggle");
    navToggle.addEventListener("click", () => {
      const navMenu = document.querySelector("nav ul");
      navMenu.classList.toggle("open");
    });
  
    // Hamburger to X toggle
    navToggle.addEventListener("click", () => {
      navToggle.classList.toggle("active");
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const mobileMenuBtn = document.querySelector('.mobile-menu');
    const mobileActionBtn = document.querySelector('.mobile-actions');

    if (!mobileMenuBtn) return;
    mobileMenuBtn.addEventListener('click', () => {
        mobileActionBtn.classList.remove('open');
        mobileMenuBtn.classList.toggle('open');
    });

    if (!mobileActionBtn) return;
    mobileActionBtn.addEventListener('click', () => {
        mobileMenuBtn.classList.remove('open');
        mobileActionBtn.classList.toggle('open');
    });
});

document.addEventListener("DOMContentLoaded", () => {
  const els = document.querySelectorAll(".reveal");

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add("is-visible");

        // If you only want it to happen once:
        obs.unobserve(entry.target);
      });
    },
    {
      root: null,
      threshold: 0.15,
      rootMargin: "0px 0px -10% 0px", // triggers a bit before fully in view
    }
  );

  els.forEach((el) => observer.observe(el));
});

document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".staff-card");

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add("is-visible");
        obs.unobserve(entry.target); // remove if you want it to re-trigger
      });
    },
    {
      threshold: 0.2,
      rootMargin: "0px 0px -10% 0px",
    }
  );

  cards.forEach((card) => observer.observe(card));
});

// Nav Functions
document.addEventListener("DOMContentLoaded", () => {
  const CLOSE_DELAY = 150;
  const MOBILE_BP = 899;
  const items = document.querySelectorAll(".main-nav .menu-item");

  const isMobile = () => window.innerWidth <= MOBILE_BP;

  items.forEach((item) => {
    const submenu = item.querySelector(":scope > .nav-submenu");
    const link = item.querySelector(":scope > a");
    if (!submenu || !link) return;

    let closeTimer = null;

    const open = () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      item.classList.add("submenu-open");
    };

    const close = () => {
      item.classList.remove("submenu-open");
    };

    const scheduleClose = () => {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(close, CLOSE_DELAY);
    };

    /* ------------------
       DESKTOP (hover)
    ------------------ */
    item.addEventListener("mouseenter", () => {
      if (isMobile()) return;
      open();
    });

    item.addEventListener("mouseleave", () => {
      if (isMobile()) return;
      scheduleClose();
    });

    submenu.addEventListener("mouseenter", () => {
      if (isMobile()) return;
      open();
    });

    submenu.addEventListener("mouseleave", () => {
      if (isMobile()) return;
      scheduleClose();
    });

    /* ------------------
       MOBILE (click)
    ------------------ */
    link.addEventListener("click", (e) => {
      if (!isMobile()) return;

      e.preventDefault(); // stop navigation

      // close other open submenus (optional but recommended)
      items.forEach((i) => {
        if (i !== item) i.classList.remove("submenu-open");
      });

      item.classList.toggle("submenu-open");
    });
  });

  /* Close all submenus if switching between mobile/desktop */
  window.addEventListener("resize", () => {
    if (!isMobile()) {
      document
        .querySelectorAll(".main-nav .submenu-open")
        .forEach((el) => el.classList.remove("submenu-open"));
    }
  });
});





  